var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "departures" },
    [
      _c("h2", { class: _vm.titleClass }, [_vm._v(_vm._s(_vm.title))]),
      _vm._v(" "),
      _c("div", {
        class: _vm.subTitleClass,
        domProps: { innerHTML: _vm._s(_vm.subTitle) },
      }),
      _vm._v(" "),
      _vm.ready
        ? [
            _vm.departures.length === 0
              ? _c(
                  "div",
                  { staticClass: "departures__no-results error-message" },
                  [
                    _c("div", { staticClass: "error-message__icon" }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "error-message__text" },
                      [_vm._t("noResultsHtml")],
                      2
                    ),
                  ]
                )
              : [
                  !_vm.hideTravelOptions
                    ? _c("div", [
                        _c("div", { staticClass: "departure__types-wrapper" }, [
                          _c(
                            "ul",
                            { staticClass: "departures__types" },
                            _vm._l(_vm.types, function (type) {
                              return _c(
                                "li",
                                {
                                  key: type.id,
                                  staticClass: "departures__type",
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "departures__type-button btn btn--outline",
                                      class: {
                                        active:
                                          _vm.activeType.name === type.name,
                                      },
                                      attrs: { disabled: !type.enabled },
                                      on: {
                                        click: function ($event) {
                                          return _vm.changeType(type)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(type.name) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            }),
                            0
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.activeType.name === _vm.firstType.name &&
                        _vm.locations.length > 1
                          ? _c(
                              "div",
                              { staticClass: "departures__location-wrapper" },
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass: "visually-hidden",
                                    attrs: { for: "departure-location" },
                                  },
                                  [_vm._v("Departing from")]
                                ),
                                _vm._v(" "),
                                _vm.locations.length
                                  ? _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.location,
                                            expression: "location",
                                          },
                                        ],
                                        staticClass: "departures__location",
                                        attrs: { id: "departure-location" },
                                        on: {
                                          change: function ($event) {
                                            var $$selectedVal =
                                              Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function (o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function (o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                            _vm.location = $event.target
                                              .multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          },
                                        },
                                      },
                                      [
                                        _c("option", { attrs: { value: "" } }, [
                                          _vm._v("Departing from"),
                                        ]),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.locations,
                                          function (location) {
                                            return _c(
                                              "option",
                                              {
                                                key: location.value,
                                                domProps: {
                                                  value: location.value,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n              " +
                                                    _vm._s(location.label) +
                                                    "\n            "
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                      ],
                                      2
                                    )
                                  : _vm._e(),
                              ]
                            )
                          : _vm._e(),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "table",
                    { staticClass: "departures__table" },
                    [
                      _c("thead", [
                        _c("tr", [
                          _c("th", [
                            _c(
                              "div",
                              {
                                staticClass: "d-flex",
                                class: _vm.sortOrderClass("date"),
                              },
                              [
                                _vm._v(
                                  "\n                Date\n                "
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "sort-icon",
                                    on: {
                                      click: function ($event) {
                                        return _vm.sortBy("date")
                                      },
                                    },
                                  },
                                  [
                                    _c("div", {
                                      staticClass: "tooltip",
                                      attrs: {
                                        "data-tooltip": "Sort by: date",
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("th", [
                            _c(
                              "div",
                              {
                                staticClass: "d-flex",
                                class: _vm.sortOrderClass(
                                  "secondaryInformation"
                                ),
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.hideTravelOptions
                                        ? "Airport"
                                        : "Duration"
                                    ) +
                                    "\n                "
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "sort-icon",
                                    on: {
                                      click: function ($event) {
                                        return _vm.sortBy(
                                          "secondaryInformation"
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("div", {
                                      staticClass: "tooltip",
                                      attrs: {
                                        "data-tooltip":
                                          _vm.secondaryInformationTooltipText,
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("th", [
                            _c(
                              "div",
                              {
                                staticClass: "d-flex",
                                class: _vm.sortOrderClass("price"),
                              },
                              [
                                _vm._v(
                                  "\n                Price\n                "
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "sort-icon",
                                    on: {
                                      click: function ($event) {
                                        return _vm.sortBy("price")
                                      },
                                    },
                                  },
                                  [
                                    _c("div", {
                                      staticClass: "tooltip",
                                      attrs: {
                                        "data-tooltip": "Sort by: price",
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("th", [
                            _c("div", { staticClass: "form-switch" }, [
                              _c("span", [_vm._v("Availability")]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.showOnlyAvailable,
                                    expression: "showOnlyAvailable",
                                  },
                                ],
                                staticClass: "form-switch-input",
                                attrs: {
                                  type: "checkbox",
                                  role: "switch",
                                  id: "flexSwitchCheckDefault",
                                },
                                domProps: {
                                  checked: Array.isArray(_vm.showOnlyAvailable)
                                    ? _vm._i(_vm.showOnlyAvailable, null) > -1
                                    : _vm.showOnlyAvailable,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a = _vm.showOnlyAvailable,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.showOnlyAvailable = $$a.concat([
                                            $$v,
                                          ]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.showOnlyAvailable = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.showOnlyAvailable = $$c
                                    }
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("label", {
                                staticClass: "form-switch-label tooltip",
                                attrs: {
                                  for: "flexSwitchCheckDefault",
                                  "data-tooltip": "View only available tours",
                                },
                              }),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("th"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.filteredDepartures, function (departure) {
                        return _c(
                          "tbody",
                          {
                            key: departure.moreDetailsUrl,
                            staticClass: "departures__tbody",
                          },
                          [
                            _c(
                              "tr",
                              {
                                staticClass: "departures__row",
                                class: departure.open
                                  ? "departures__row--open"
                                  : "",
                                on: {
                                  click: function ($event) {
                                    return _vm.toggleDetails(departure)
                                  },
                                },
                              },
                              [
                                _c("td", { class: _vm.cellClass }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(departure.date) +
                                      "\n            "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("td", { class: _vm.cellClass }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(departure.secondaryInformation) +
                                      "\n            "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("td", { class: _vm.cellClass }, [
                                  departure.tourSummary.hasWasFromPrice
                                    ? _c("span", { class: _vm.wasPriceClass }, [
                                        _vm._v(
                                          _vm._s(
                                            departure.tourSummary
                                              .wasPriceFormatted
                                          )
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        departure.tourSummary.fromPriceFormatted
                                      ) +
                                      "\n            "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("td", { class: _vm.cellClass }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(departure.status) +
                                      "\n            "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("td", { class: _vm.cellClass }, [
                                  _c("span", { class: _vm.arrowClass }),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            departure.details && departure.open
                              ? _c("tr", [
                                  _c("td", { attrs: { colspan: "6" } }, [
                                    _c(
                                      "div",
                                      { staticClass: "d-flex flex-column" },
                                      [
                                        departure.available > 0
                                          ? _c("div", [
                                              _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "departures__book-now btn",
                                                  attrs: {
                                                    href: departure.details
                                                      .bookNowLink.url,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.handleBookNowClick(
                                                        $event,
                                                        departure
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      departure.details
                                                        .bookNowLink.name
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("YourHoliday", {
                                          attrs: {
                                            departureDetails: departure.details,
                                            brand: _vm.brand,
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]),
                                ])
                              : _vm._e(),
                          ]
                        )
                      }),
                    ],
                    2
                  ),
                ],
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.apiError && !_vm.ready
        ? [
            _c("div", { staticClass: "departures__no-results error-message" }, [
              _c("div", { staticClass: "error-message__icon" }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "error-message__text" },
                [_vm._t("apiUnavailableHtml")],
                2
              ),
            ]),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.types && !_vm.firstType
        ? [
            _c("div", { staticClass: "departures__no-results error-message" }, [
              _c("div", { staticClass: "error-message__icon" }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "error-message__text" },
                [_vm._t("noResultsHtml")],
                2
              ),
            ]),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }